export default (tracker) => ({
  async seen(data) {
    await tracker.track('Signup Modal Seen', data)
  },

  async closed(data) {
    await tracker.track('Signup Modal Closed', data)
  },

  async interactedDiscount(data) {
    await tracker.track('Discount Code Copied', data)
  },

  async exited(data) {
    await tracker.track('Exit Gate Clicked', data)
  },

  async toastClosed(data) {
    await tracker.track('Signup Toast Notification Closed', data)
  },

  async toastClicked(data) {
    await tracker.track('Signup Toast Notification Clicked', data)
  },

  async givenPreferences(data) {
    await tracker.track('Content Preferences Given', data)
  },

  async completedSignup(data) {
    await tracker.track('Completed SunGod+ Signup', data)
  },

  async multiCompetitionEntered(data) {
    await tracker.track('Multi Competition Entered', data)
  },
})
